module.exports = __webpack_public_path__ + "media/favicon/favicon-16x16-c810f8a4.png";